import type {
  ICreateFolderPayload,
  ICreatePromptPayload,
  IGetPromptsParams,
  IPromptLibraryFolder,
  IPromptLibraryPrompt,
  ISearchPromptsParams,
  IUpdateFolderParams,
  IUpdatePromptParams,
} from "../types";
import type { ApiClient } from "./client";

export class PromptLibraryApi {
  constructor(private apiClient: ApiClient) {}

  async getFolders(): Promise<IPromptLibraryFolder[]> {
    const response = await this.apiClient.get<IPromptLibraryFolder[]>(
      "/prompt-library/folders",
    );
    return response.data;
  }

  async createFolder(
    data: ICreateFolderPayload,
  ): Promise<IPromptLibraryFolder> {
    const response = await this.apiClient.post<IPromptLibraryFolder>(
      "/prompt-library/folder",
      data,
    );
    return response.data;
  }

  async updateFolder({
    uuid,
    data,
  }: IUpdateFolderParams): Promise<IPromptLibraryFolder> {
    const response = await this.apiClient.put<IPromptLibraryFolder>(
      `/prompt-library/folders/${uuid}`,
      data,
    );
    return response.data;
  }

  async deleteFolder(uuid: string): Promise<void> {
    await this.apiClient.delete(`/prompt-library/folders/${uuid}`);
  }

  async getPrompts(params: IGetPromptsParams): Promise<IPromptLibraryPrompt[]> {
    const response = await this.apiClient.get<IPromptLibraryPrompt[]>(
      `/prompt-library/folders/${params.folderUuid}/prompts`,
    );
    return response.data;
  }

  async createPrompt(
    data: ICreatePromptPayload,
  ): Promise<IPromptLibraryPrompt> {
    const { folderUuid, ...body } = data;
    const response = await this.apiClient.post<IPromptLibraryPrompt>(
      `/prompt-library/folders/${folderUuid}/prompt`,
      body,
    );
    return response.data;
  }

  async updatePrompt({
    uuid,
    folderUuid,
    data,
  }: IUpdatePromptParams): Promise<IPromptLibraryPrompt> {
    const response = await this.apiClient.put<IPromptLibraryPrompt>(
      `/prompt-library/folders/${folderUuid}/prompts/${uuid}`,
      data,
    );
    return response.data;
  }

  async deletePrompt(folderUuid: string, promptUuid: string): Promise<void> {
    await this.apiClient.delete(
      `/prompt-library/folders/${folderUuid}/prompts/${promptUuid}`,
    );
  }

  async searchPrompts(
    params: ISearchPromptsParams,
  ): Promise<IPromptLibraryPrompt[]> {
    const response = await this.apiClient.get<IPromptLibraryPrompt[]>(
      "/prompt-library/search",
      { params: { query: params.search } },
    );
    return response.data;
  }
}
